import { useCallback, useState } from 'react';
import { IconButton, MenuItem } from '@mui/material';
import { MoreHoriz as MoreIcon } from '@mui/icons-material';
import { DropdownProps, Dropdown } from '@localstack/ui';
import { GetInvitationResponse } from '@localstack/types';

export interface InvitationActionsDropdownProps {
  invitation: GetInvitationResponse;
  disabled: boolean;
  onResendInvitation?: (invitationId: string) => Promise<void>;
  onRevokeInvitation: (invitationId: string) => Promise<void>;
}

export const InvitationActionsDropdown = ({
  invitation,
  disabled = false,
  onResendInvitation,
  onRevokeInvitation,
}: InvitationActionsDropdownProps): JSX.Element => {
  const [isBusy, setIsBusy] = useState(false);

  const resendInvitation = useCallback(
    async (invitationId: string) => {
      if (!onResendInvitation) return;
      setIsBusy(true);
      await onResendInvitation(invitationId);
      setIsBusy(false);
    },
    [onResendInvitation],
  );

  const revokeInvitation = useCallback(async (invitationId: string) => {
    setIsBusy(true);
    await onRevokeInvitation(invitationId);
    setIsBusy(false);
  }, []);

  return (
    <Dropdown
      size="small"
      menuListProps={{ disablePadding: true }}
      renderButton={({ onClick }: DropdownProps) => (
        <IconButton onClick={onClick} disabled={disabled}>
          <MoreIcon />
        </IconButton>
      )}
    >
      {onResendInvitation && (
        <MenuItem disabled={isBusy} onClick={() => resendInvitation(invitation.id)}>
          Resend invitation
        </MenuItem>
      )}
      <MenuItem disabled={isBusy} onClick={() => revokeInvitation(invitation.id)}>
        Revoke invitation
      </MenuItem>
    </Dropdown>
  );
};
